<template>
	<div class="plan-coverage">
		<div class="coverage-title">{{ title }}</div>
		<PricedItem :title="'Limit'" :amount="limit" />
		<PricedItem v-for="(amount, title) in sublimits" :key="title" :title="title" :amount="amount" />
		<PricedItem :title="'Deductible'" :amount="deductible" />
		<Accordion class="coverage-description" v-if="desciptionAccordion.body">
			<div class="wysiwyg-content" slot="header" v-html="desciptionAccordion.header" />
			<div class="wysiwyg-content" slot="body" v-html="desciptionAccordion.body" />
		</Accordion>
		<div class="coverage-description wysiwyg-content" v-else v-html="desciptionAccordion.header" />
	</div>
</template>

<script>
import Accordion from "@/components/base/Accordion";
import PricedItem from "@/components/base/PricedItem";

export default {
	name: 'PlanCoverage',
	components: {
		Accordion,
		PricedItem,
	},
	props: {
		id: {
			type: Number,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
		deductible: {
			type: Number,
			required: true,
		},
		limit: {
			type: Number,
			required: true,
		},
		sublimits: {
			type: [Object, Array],
			required: false,
		},
		description: {
			type: String,
			required: false,
		},
	},
	computed: {
		desciptionAccordion() {
			const index = this.description.indexOf("</p>") + 4; // +4 to include the </p>
			const header = this.description.substr(0, index);
			const body = this.description.substr(index).trim();

			return { header, body };
		},
	},
};

</script>

<style lang="scss" scoped>
	.plan-coverage {
		color: white;
		margin-bottom: 20px;
	}

	.coverage-title {
		font-family: $heading-font;
		letter-spacing: $letter-spacing-plus;
		text-transform: uppercase;
	}

	.coverage-description {
		color: $gray-light;
		font-size: $font-size-sm;

		.wysiwyg-content { margin-bottom: 0; }
	}
</style>
